export const MOBILE_IMAGE_HEIGHT = '200px'
export const MOBILE_IMAGE_WIDTH = '250px'
export const MOBILE_MARGIN = 2

export const DESKTOP_MARGIN = 8
export const DESKTOP_IMAGE_HEIGHT = '400px'
